import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { KeyTopicTwoComponent } from './components/key-topic-two.component';
import { KeyTopicTwoBlockConfiguration } from './models/key-topic-two.models';
import { SanitizeHtmlPipe } from '../../pipes/sanitize-html.pipe';

@Component({
    selector: 'nw-key-topic-two-block',
    imports: [KeyTopicTwoComponent, SanitizeHtmlPipe],
    templateUrl: './key-topic-two-block.component.html',
    styleUrl: './key-topic-two-block.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class KeyTopicTwoBlockComponent {
    @Input() heading?: string;
    @Input() topics: KeyTopicTwoBlockConfiguration.Topic[] = [];
}
